import { Brand } from '@blade/std-lib'

export const LimitOrderIdTypeId = 'tradebot-tma/LimitOrderId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type LimitOrderIdTypeId = typeof LimitOrderIdTypeId

export type LimitOrderId = Brand.Branded<string, LimitOrderIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LimitOrderId = Brand.nominal<LimitOrderId>()
